import { useDelete } from "@refinedev/core";
import { useOrganization } from "hooks/useOrganization";
import { Subscription } from "types";

const useDeleteSubscription = (id: string) => {
  const { mutateAsync, isLoading } = useDelete<Subscription>();
  const { organization } = useOrganization({});
  const resource = `api/organizations/${organization?.id}/payments`;
  const deleteSubscription = async () =>
    await mutateAsync({ resource, id, successNotification: false });

  return { deleteSubscription, isLoading };
};

export default useDeleteSubscription;
